"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = bind;
/**
 * Bind the given method to the current context, useful for binding class methods as event handlers.
 *
 * In the example below, without the @bind property, the onClick method would have lost the class context.
 * <code>
 *   class Example {
 *       constructor() {
 *           document.addEventListener('click', this.onClick);
 *       }
 *
 *       @bind
 *       private onClick(event: MouseEvent): void {
 *       }
 *   }
 * </code>
 */
function bind(_target, propertyKey, descriptor) {
    /* istanbul ignore if */
    if (descriptor === undefined || typeof descriptor.value !== 'function') {
        throw new TypeError(`Only methods can be decorated with @bind. <${propertyKey}> is not a method!`);
    }
    const fn = descriptor.value;
    return {
        configurable: true,
        get() {
            const bound = fn.bind(this);
            Object.defineProperty(this, propertyKey, { value: bound, configurable: true, writable: true });
            return bound;
        }
    };
}
//# sourceMappingURL=Bind.js.map